import type { TextAlign } from '../../shared/types/text-align';

// The model omits a field when it holds its default, so a missing field means these values —
// never "leave whatever the canvas shows". The renderer writes them all, every time.
export const TEXT_DEFAULTS = {
  fontFamily: 'Arial',
  fontSize: 24,
  fontWeight: 'normal' as string | number,
  fontStyle: 'normal' as 'normal' | 'italic',
  textAlign: 'left' as TextAlign,
  lineHeight: 1.16,
  charSpacing: 0,
  underline: false
};
